import React from 'react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function PostCTAReassurance() {
  return <section className="pt-6 pb-10 bg-slate-900" data-id="element-585">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-586">
        <ScrollFadeIn data-id="element-587">
          <p className="text-2xl font-serif text-slate-50 mb-6" data-id="element-588">
            Still here? Let me be direct.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-589">
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-590">
            If you're over 40, running on caffeine and willpower, waking up
            exhausted, and watching your midsection get harder to shift — this
            system was built specifically for you.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-591">
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-592">
            It's not theory. It's not generic wellness advice. It's a targeted
            biological protocol for the exact hormonal environment of a stressed
            40+ body.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-593">
          <p className="text-xl font-bold text-amber-500" data-id="element-594">
            You've already tried the harder path. This is the smarter one.
          </p>
        </ScrollFadeIn>
      </div>
    </section>;
}